import { FC } from 'react';
import classNames from 'classnames';

import { PlusSubscriptionLogo } from 'src/components/plusSubscription/modals/icons/Logo';
import { PlusSubscriptionUpgradeNowModalClose } from 'src/components/plusSubscription/modals/icons/Close';
import { BaseSeparateModal } from 'src/models/modals';

import styles from 'src/styles/common/plusSubscription/modal/modalHeader.module.scss';
import { PlusSubscriptionSliceStateType } from 'src/store/plusSubscription/slice';
import { PlusSubscriptionLogoUnlimited } from 'src/components/plusSubscription/modals/icons/LogoUnlimited';

type Props = BaseSeparateModal & {
  type: Extract<
    PlusSubscriptionSliceStateType['modal']['type'],
    'planSelection' | 'trialExpired' | 'upgradeNow' | 'unlimited'
  >;
  showHeader: boolean;
};

export const PlusSubscriptionHeader: FC<Props> = ({ onClose, type, showHeader }) =>
  showHeader ? (
    <div className={classNames(styles.header, type === 'unlimited' && styles.isUnlimited)}>
      <button type="button" onClick={onClose} className={styles.close}>
        <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
      </button>

      {type === 'unlimited' ? (
        <PlusSubscriptionLogoUnlimited className={classNames(styles.logo, styles.unlimited)} />
      ) : (
        <PlusSubscriptionLogo className={styles.logo} />
      )}
    </div>
  ) : (
    <button type="button" onClick={onClose} className={styles.close}>
      <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
    </button>
  );
